require("../../sass/core.sass");

let browserHistory = require("react-router").browserHistory;
let Provider = require("react-redux").Provider;
import React from "react";
let Router = require("react-router").Router;
let Route = require("react-router").Route;

let Modal = require("./modal");
let ModerationContainer = require("./moderation-container");

import store from "../stores/reduxStore";

class ModerationTool extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <div style={{ width: "100%" }}>
                    <Router history={browserHistory}>
                        <Route
                            path="/fort/modparty/(:slug)/"
                            component={ModerationContainer}
                        />
                        <Route
                            path="/fort/modparty/(:slug)/preview/(:previewUploadId)/"
                            component={ModerationContainer}
                        />
                    </Router>
                    <Modal />
                </div>
            </Provider>
        );
    }
}

module.exports = ModerationTool;
